export interface NavbarLink {
    href: string;
    labelKey:
        | "analiz"
        | "bulmacalar"
        | "positional"
        | "tactical"
        | "puzzleRush"
        | "puzzleBattle"
        | "savedGames"
        | "studies"
        | "editor"
        | "egitimler"
        | "eglence"
        | "etkinlikler"
        | "haberler"
        | "urunler";
}

export const puzzleLinks: NavbarLink[] = [
    {
        href: "/bulmacalar?gm=puzzles&pt=taktiksel",
        labelKey: "tactical",
    },
    {
        href: "/bulmacalar?gm=puzzles&pt=pozisyonel",
        labelKey: "positional",
    },
    { href: "/bulmacalar?gm=puzzleRush", labelKey: "puzzleRush" },
    { href: "/bulmacalar?gm=puzzleBattle", labelKey: "puzzleBattle" },
];

export const videoLinks: NavbarLink[] = [
    { href: "/seri/egitimler", labelKey: "egitimler" },
    { href: "/seri/eglence", labelKey: "eglence" },
];

export const communityLinks: NavbarLink[] = [
    { href: "/haberler", labelKey: "haberler" },
    { href: "/etkinlikler", labelKey: "etkinlikler" },
];

// Hidden until launch: the pages are live but only reachable by direct URL.
// Flip to true to show the "learn" menu in the navbar.
export const SHOW_LEARN_LINKS = false;

export const learnLinks: NavbarLink[] = [
    { href: "/editor", labelKey: "editor" },
    { href: "/analiz", labelKey: "analiz" },
    { href: "/oyunlar", labelKey: "savedGames" },
    { href: "/calismalar", labelKey: "studies" },
];

export const storeLink: NavbarLink = {
    href: "/urunler",
    labelKey: "urunler",
};
